//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Column, Row, TitleSection } from "components/styles";
import { AboutSchedule, Container, Content, ScheduleCard } from "../styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import { CustomRadio } from "components/CustomRadio/CustomRadio";
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
//#endregion
//#region Icons
import LocationIcon from "icons/LocationIcon";
import RemoteIcon from "icons/RemoteIcon";
import TimerIcon from "icons/TimerIcon";
import CalendarIcon from "icons/CalendarIcon";
//#endregion
//#region Services
import { requestReassignSchedule } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import { LOADING_MESSAGES } from "../../Popups/constants";
import { getTextByRangeMinutes } from "components/CustomTimePicker/utils";
import { 
    getDateMonthString, getDatePartsByMillis, 
    getTodayWithoutHourInMillis,
    MONTHS,
    WEEK_DAYS } from "components/CustomDatePicker/utils/helpers";
import useMainContext from "utils/context/useMainContext";
//#endregion

const getFormattedDate = timestamp => {
    const dateObj = new Date(timestamp);
    const dayName = WEEK_DAYS[dateObj.getDay()].substring(0, 3);
    const monthName = MONTHS[dateObj.getMonth()].substring(0, 3);
    return `${dayName}, ${dateObj.getDate()} ${monthName} ${dateObj.getFullYear()}`;
}

const DialogScheduleReassignment = ({
    show, toggleShow,
    dateTimeData: { date, hour },
    reservation, schedules, 
    setLoadingService, reloadData,
    isPresential
}) => {
    const mainContext = useMainContext();
    //#region States
    const [appointmentDateId, setAppointmentDateId] = useState(0);
    //#endregion
    //#region Functions
    const changeAppointmentDateId = (value) => {
        setAppointmentDateId(value);
    }
    const getReassignmentSuccessMessage = () => {
        const todayPrefix = date === -1 || getTodayWithoutHourInMillis() === date ? "Hoy " : "";
        const monthDate = getDatePartsByMillis(date).slice(1);
        const adviserName = schedules.find(({ appointmentDateId: currentAppointmentDateId }) => appointmentDateId === currentAppointmentDateId).adviser.name;
        return {
            message: `${todayPrefix}${getDateMonthString(monthDate, 1)}, ${reservation.studentName} ha sido reasignado con el asesor ${adviserName} con horario ${hour}:00 a ${hour+1}:00`,
            variant: "success",
            milis: 5000
        };
    }
    const reassignSchedule = async () => {
        toggleShow(false);
        const newLoadingService = {
            loading: true,
            message: LOADING_MESSAGES.UPDATE
        };
        setLoadingService({ ...newLoadingService });
        const success = await requestReassignSchedule({
            reservationId: reservation.id, 
            appointmentDateId
        });
        setLoadingService({ ...newLoadingService, loading: false });
        if (success) reloadData(getReassignmentSuccessMessage());
        else mainContext.setShowDialogUnexpectedError(true);
    }
    //#endregion
    return (
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}
            close={() => toggleShow(false)}
            variant="reassignment">
            <CloseButton onClick={() => toggleShow(false)}/>
            <Column 
                align="center" 
                gap="24px"
                marginTop="46px">
                <TitleSection 
                    fontWeight="900" 
                    width="100%"
                    textAlign="center"
                    margin="0">Asesores disponibles en este horario </TitleSection>
                <Container>
                    <Content>
                        {schedules.map(schedule => (
                            <ScheduleItem
                                key={schedule.appointmentDateId}
                                adviser={schedule.adviser}
                                checked={appointmentDateId === schedule.appointmentDateId}
                                isPresential={isPresential}
                                dateStr={getFormattedDate(
                                    date === -1 ? getTodayWithoutHourInMillis() : date
                                )}
                                timeStr={getTextByRangeMinutes({
                                    start: hour * 60,
                                    end: (hour + 1) * 60
                                })}
                                onChange={() => changeAppointmentDateId(schedule.appointmentDateId)}/>
                        ))}
                    </Content>
                </Container>
                <Row width="100%" justifyContent="center" gap="16px">
                    <CustomButton 
                        variant="secondary" 
                        size="medium" 
                        width="87px"
                        text="Cancelar"
                        onClick={() => toggleShow(false)}/>
                    <CustomButton 
                        size="medium" 
                        disabled={appointmentDateId === 0}
                        width="82px"
                        text="Agregar"
                        onClick={reassignSchedule}/>
                </Row>
            </Column>
        </DialogAlert>
    );
}

const ScheduleItem = ({
    checked,
    onChange,
    isPresential,
    adviser,
    dateStr, timeStr
}) => {
    return (
        <ScheduleCard>
            <CustomRadio
                label={adviser.name}
                checked={checked}
                onChange={onChange}
                fontSizeLabel="14px"/>
            <AboutSchedule>
                {isPresential
                ? <Row gap="7px">
                    <LocationIcon size={18}/>
                    <span>Lugar</span>
                </Row>
                : <Row gap="7px">
                    <RemoteIcon size={16}/>
                    <span>Zoom</span>
                </Row>}
                <Row gap="7px">
                    <CalendarIcon size={16}/>
                    <span>{dateStr}</span>
                </Row>
                <Row gap="7px">
                    <TimerIcon size={16}/>
                    <span>{timeStr}</span>
                </Row>
            </AboutSchedule>
        </ScheduleCard>
    );
}

export default DialogScheduleReassignment;
